import { render, staticRenderFns } from "./operationBtn.vue?vue&type=template&id=35254cd3&scoped=true"
import script from "./operationBtn.vue?vue&type=script&lang=js"
export * from "./operationBtn.vue?vue&type=script&lang=js"
import style0 from "./operationBtn.vue?vue&type=style&index=0&id=35254cd3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35254cd3",
  null
  
)

export default component.exports